import { render, staticRenderFns } from "./RegionPlansStatistics.vue?vue&type=template&id=d4b1e052"
import script from "./RegionPlansStatistics.vue?vue&type=script&lang=js"
export * from "./RegionPlansStatistics.vue?vue&type=script&lang=js"
import style0 from "./RegionPlansStatistics.vue?vue&type=style&index=0&id=d4b1e052&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports